"use client";

import { clsx } from "@trydig/ui";
import type { PropsWithChildren } from "react";
import { Arrow } from "~/components/icons/32/Arrow";
import styles from "~/features/products/RelatedProductsCarousel/RelatedProductsCarousel.module.css";
import { useSlider } from "~/lib/hooks/useSlider";

export const ClientProductSlider = ({
	title = "Relaterte produkter",
	children,
}: PropsWithChildren<{ title?: string }>) => {
	const { emblaRef, prevBtnEnabled, nextBtnEnabled, scrollPrev, scrollNext } = useSlider();
	return (
		<section data-layout="section" className={styles.carousel}>
			<h2 className={styles["heading-2"]}>{title}</h2>

			<div className={styles.embla} ref={emblaRef}>
				<div className={styles.embla__container}>{children}</div>
			</div>

			<div className={styles["gallery-button-wrapper"]}>
				{prevBtnEnabled && (
					<button
						disabled={!prevBtnEnabled}
						onClick={(e) => {
							e.stopPropagation();
							scrollPrev();
						}}
						className={styles["gallery-button"]}
					>
						<Arrow />
					</button>
				)}
				{nextBtnEnabled && (
					<button
						disabled={!nextBtnEnabled}
						onClick={(e) => {
							e.stopPropagation();
							scrollNext();
						}}
						className={clsx(styles["gallery-button"], styles.right)}
					>
						<Arrow />
					</button>
				)}
			</div>
		</section>
	);
};
